module.exports = __webpack_public_path__ + "static/media/logo-icon.2929b2a3.svg";